import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { Alert } from 'antd';

export default class GenericErrorBoundary extends React.Component {
  /*
  Wrapper class for returning an error span when rendering of children breaks
   */

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    Sentry.captureException(error);
    // eslint-disable-next-line no-console
    console.log('getDerivedStateFromError', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    Sentry.captureException(error);
    // eslint-disable-next-line no-console
    console.log('componentDidCatch', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (<Alert type="error" showIcon message="Something went wrong." />);
    }

    return children;
  }
}

GenericErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};
